import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import getTitle from '../../../../common/translations';
import { useLanguage } from '../../../../context/LanguageContext';
import { getCommonStyles } from '../../../../common/commonStyles';

interface Props {
    dialogOpen: boolean;
    handelDialogOpen: () => void;
    itemName: string;
    handleDelete: () => void;
}

export const DeleteDialog = ({ dialogOpen, handelDialogOpen, itemName, handleDelete }: Props) => {
    const { language } = useLanguage();
    const buttonStyle = { lineHeight: '1.25rem' /* fontSize: '0.75rem' */ };
    const { simpleBtnStyle } = getCommonStyles();
    const [isDeleteValueValid, setIsDeleteValueValid] = useState<boolean>(false);

    const checkDeleteValue = (e: any) => {
        if (e.target.value === itemName) {
            setIsDeleteValueValid(true);
        } else {
            setIsDeleteValueValid(false);
        }
    };

    return (
        <Dialog fullWidth open={dialogOpen} onClose={handelDialogOpen}>
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>Delete item: {itemName}</Box>
                    <Box>
                        <Button variant="outlined" onClick={handelDialogOpen} sx={{ ...buttonStyle, ...simpleBtnStyle }}>
                            {getTitle(language, 'close')}
                        </Button>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box>You definitely want to delete the recipe: {itemName} ?</Box>
                <Box>
                    To delete, write in the box below:{' '}
                    <Typography variant={'h6'} component={'span'}>
                        {' '}
                        {itemName}
                    </Typography>
                </Box>
                <TextField fullWidth color={isDeleteValueValid ? 'success' : 'error'} placeholder={itemName} onChange={checkDeleteValue} />
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button id="delete" variant="contained" onClick={handleDelete} color="error" disabled={!isDeleteValueValid}>
                    {getTitle(language, 'delete')}
                </Button>
                <Button variant="outlined" onClick={handelDialogOpen}>
                    {getTitle(language, 'cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
